import { render, staticRenderFns } from "./checkData.vue?vue&type=template&id=0d4f7ea5&scoped=true&"
import script from "./checkData.vue?vue&type=script&lang=js&"
export * from "./checkData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f7ea5",
  null
  
)

export default component.exports